/**
 * Universal function for validating input fields.
 * @param {Array} inputs - Array of input field objects.
 * @param {Function} t - Translation function (optional).
 */
export function useValidation() {
  const validateInputs = (inputs, t = key => key) => {
    inputs.forEach((input) => {
      if (input.rules) {
        const failedRule = input.rules.find(rule => !rule(input.value))
        input.error = failedRule ? failedRule.message || t("auth.invalidInput") : ""
      }
    })
  }

  return {
    validateInputs,
  }
}
